import { render, staticRenderFns } from "./ClientForPos.vue?vue&type=template&id=197fe9fd&scoped=true"
import script from "./ClientForPos.vue?vue&type=script&lang=js"
export * from "./ClientForPos.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ClientForPos.vue?vue&type=style&index=1&id=197fe9fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197fe9fd",
  null
  
)

export default component.exports